import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import React from "react";

export type Breadcrumb = {
  title: string;
  isLink?: boolean;
  to?: string;
  key: string;
};

type Props = {
  items: Breadcrumb[];
  homeType?: "space" | "organization";
};

const Breadcrumbs = ({ items, homeType = "space" }: Props) => {
  const homeCrumb =
    homeType === "space" ? (
      <Link
        key="home"
        component={RouterLink}
        to="/space/overview"
        display="flex"
        aria-label="Space Dashboard"
      >
        <HomeIcon fontSize="inherit" />
      </Link>
    ) : (
      <Link
        key="/dashboard"
        component={RouterLink}
        to={`/dashboard`}
        display="flex"
        aria-label="Organization Dashboard"
      >
        <HomeIcon fontSize="inherit" />
      </Link>
    );

  const itemCrumbs = items.map((item) =>
    item.isLink && item.to ? (
      <Link key={item.key} component={RouterLink} to={item.to} display="flex">
        {item.title}
      </Link>
    ) : (
      <Typography key={item.key}>{item.title}</Typography>
    ),
  );

  return (
    <MuiBreadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
      {[homeCrumb, ...itemCrumbs]}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
